export default __webpack_public_path__ + "static/media/Peso-cost Averaging.7b187c88.png";